module.exports = __webpack_public_path__ + "static/media/history.f7bddf60.svg";